import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
const Footer = () => {
    const footeren = {
        "1": "Company",
        "2": "Home",
        "3": "About Us",
        "4": "Our Products",
        "5": "Contact Us",
        "6": "Important",
        "7": "FAQ",
        "8": "Privacy Policy",
        "9": "Shipping policy",
        "10": "Terms & Conditions",
        "11": "Exchange & Return Policy",
        "12": "Cancellation & Refund",
        "13": "Quick Link",
        "14": "Login",
        "15": "Official Info",
        "16": "Location",
        "17": "230, 2B Cross, Kasturi Nagar, Bengaluru - 560043",
        "18": "Email",
        "19": "Phone",
        "20": "Terra Clenz. All Rights Reserved"
    }
    const footerta = {
        "1": "நிறுவனம்",
        "2": "முகப்பு",
        "3": "எங்களை பற்றி",
        "4": "எங்கள் தயாரிப்புகள்",
        "5": "தொடர்புக்கு",
        "6": "முக்கியமானவை",
        "7": "கேள்விகள் & பதில்கள் (FAQ)",
        "8": "தனியுரிமைக் கொள்கை",
        "9": "ஷிப்பிங் கொள்கை",
        "10": "விதிமுறைகள் & நிபந்தனைகள்",
        "11": "மாற்றம் & திரும்பப் பெறும் கொள்கை",
        "12": "ரத்தாக்கல் & மீள்பணம்",
        "13": "விரைவு இணைப்பு",
        "14": "உள்நுழைவு",
        "15": "அதிகாரப்பூர்வ தகவல்",
        "16": "இருப்பிடம்",
        "17": "230, 2B கிராஸ், கஸ்தூரி நகர், பெங்களூரு - 560043",
        "18": "மின்னஞ்சல்",
        "19": "தொலைபேசி",
        "20": "Terra Clenz. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை"
    }
    const footerka = {
        "1": "ಕಂಪನಿ",
        "2": "ಪ್ರಥಮ ಪುಟ",
        "3": "ನಮ್ಮ ಬಗ್ಗೆ",
        "4": "ನಮ್ಮ ಉತ್ಪನ್ನಗಳು",
        "5": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        "6": "ಪ್ರಮುಖ",
        "7": "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
        "8": "ಗೌಪ್ಯತಾ ನೀತಿ",
        "9": "ಸಾಗಣೆ ನೀತಿ",
        "10": "ನಿಯಮ ಮತ್ತು ಶರತ್ತುಗಳು",
        "11": "ವಿನಿಮಯ ಮತ್ತು ವಾಪಸಾತಿ ನೀತಿ",
        "12": "ರದ್ದತಿ ಮತ್ತು ಮರುಪಾವತಿ",
        "13": "ತ್ವರಿತ ಲಿಂಕ್",
        "14": "ಲಾಗಿನ್ ಮಾಡಿ",
        "15": "ಅಧಿಕೃತ ಮಾಹಿತಿ",
        "16": "ಸ್ಥಳ",
        "17": "230, 2ಬಿ ಕ್ರಾಸ್, ಕಸ್ತೂರಿ ನಗರ, ಬೆಂಗಳೂರು - 560043",
        "18": "ಇಮೇಲ್",
        "19": "ದೂರವಾಣಿ",
        "20": "ಟೆರ್ರಾ ಕ್ಲೆನ್ಜ್ . ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ."
    }
    

    const footerte = {
        "1": "కంపెనీ",
        "2": "హోం",
        "3": "మా గురించి",
        "4": "మా ఉత్పత్తులు",
        "5": "మమ్మల్ని సంప్రదించండి",
        "6": "ముఖ్యం",
        "7": "తరచుగా అడిగే ప్రశ్నలు",
        "8": "గోప్యతా విధానం",
        "9": "రవాణా విధానం",
        "10": "నిబంధనలు & షరతులు",
        "11": "మార్పిడి & రీఫండ్ విధానం",
        "12": "రద్దు & తిరిగి చెల్లింపు",
        "13": "త్వరిత లింక్",
        "14": "లాగిన్",
        "15": "అధికారిక సమాచారం",
        "16": "స్థానం",
        "17": "230, 2బీ క్రాస్, కస్తూరి నగర్, బెంగళూరు - 560043",
        "18": "ఇమెయిల్",
        "19": "ఫోన్",
        "20": "టెర్రా క్లెన్జ్. అన్ని హక్కులు కలదిగా ఉన్నాయి."
    }
    const footerhi ={
        "1": "कंपनी",
        "2": "होम",
        "3": "हमारे बारे में",
        "4": "हमारे उत्पाद",
        "5": "संपर्क करें",
        "6": "महत्वपूर्ण",
        "7": "सामान्य प्रश्न (FAQ)",
        "8": "गोपनीयता नीति",
        "9": "शिपिंग नीति",
        "10": "नियम और शर्तें",
        "11": "विनिमय और वापसी नीति",
        "12": "रद्दीकरण और धनवापसी",
        "13": "त्वरित लिंक",
        "14": "लॉगिन",
        "15": "आधिकारिक जानकारी",
        "16": "स्थान",
        "17": "230, 2बी क्रॉस, कस्तूरी नगर, बेंगलुरु - 560043",
        "18": "ईमेल",
        "19": "फोन",
        "20": "टेरा क्लेंज। सभी अधिकार सुरक्षित"
    }
    
    const [footer, setHomeen] = useState(footeren)

    useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
    switch (storedLanguage) {
        case "kn":
            setHomeen(footerka);
            break;
        case "te":
            setHomeen(footerte);
            break;
        case "ta":
            setHomeen(footerta);
            break;
            case "hi":
            setHomeen(footerhi);
            break;
        default:
                setHomeen(footeren);
    }

}, []);
    return (
        <>
            <footer class="footer-wrap">
                <div class="container" style={{maxWidth:"100%"}}>
                    <div class="row pt-20">
                        <div class="col-xl-3 col-lg-5 col-md-5 col-sm-12">
                            <div class="footer-widget">
                                <a href="/" class="footer-logo">
                                    <img src="assets/img/Logo23-02.gif" alt="Image" style={{height:"30vh"}}/>
                                </a>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6">
                            <div class="footer-widget">
                                <h3 class="footer-widget-title" style={{ textAlign: "left" }}>{footer["1"]}</h3>
                                <ul class="footer-menu list-style" style={{ textAlign: "left", padding: 0 }}>
                                    <li>
                                        <Link to="/">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["2"]}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/aboutus">    
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["3"]}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/products">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["4"]}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/contactus">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["5"]}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6">
                            <div class="footer-widget">
                                <h3 class="footer-widget-title" style={{ textAlign: "left" }}>{footer["6"]}</h3>
                                <ul class="footer-menu list-style" style={{ textAlign: "left", padding: 0 }}>

                                    <li>
                                        <a href="/FAQs">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["7"]}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/Privacy-policy">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["8"]}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/Shipping-policy">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["9"]}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/Terms-and-Conditions-policy">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["10"]}
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a href="/Exchange-and-Return-policy">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["11"]}
                                        </a>
                                    </li> */}
                                    {/* <li>
                                        <a href="/Cancellation-and-Refund-policy">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["12"]}
                                        </a>
                                    </li> */}

                                </ul>
                            </div>
                        </div>
                        {/* <div class="col-xl-2 col-lg-5 col-md-6 col-sm-6 pe-xl-4">
                            <div class="footer-widget">
                                <h3 class="footer-widget-title" style={{ textAlign: "left" }}>{footer["13"]}</h3>
                                <ul class="footer-menu list-style" style={{ textAlign: "left", padding: 0 }}>
                                    <li>
                                        <Link to="/login">
                                            <i class="ri-arrow-right-s-line"></i>
                                            {footer["14"]}
                                        </Link>
                                    </li>

                                </ul>
                            </div>
                        </div> */}
                        <div class="col-xl-4 col-lg-7 col-md-6 col-sm-6">
                            <div class="footer-widget ">
                                <h3 class="footer-widget-title" style={{ textAlign: "left" }}>{footer["15"]}</h3>
                                <ul class="contact-info list-style" style={{ textAlign: "left", padding: 0 }}>
                                    <li>
                                        <i class="flaticon-map" style={{color:"#000"}}></i>
                                        {/* <h6 style={{    color:"#000"}}>{footer["16"]}</h6> */}
                                        <p style={{    color:"#000"}}>{footer["17"]}</p>
                                    </li>
                                    <li>
                                    <i className="flaticon-email-1" style={{ color:"#000" }}></i>

                                        {/* <h6 style={{    color:"#000"}}>{footer["18"]}</h6> */}
                                        <a style={{    color:"#000"}} href="mailto:business@terrainternational.in?subject=Inquiry&body=Hello,%20I%20would%20like%20to%20know%20more."><span class="__cf_email__">business@terrainternational.in</span></a>
                                    </li>
                                    <li>
                                        <i class="flaticon-phone-call-1" style={{color:"#000"}}></i>
                                        {/* <h6 style={{ color: "#000000" }}>{footer["19"]}</h6> */}
                                        <a style={{    color:"#000"}} href="tel:+917022519222" className="new_karthik_heading_here">+91  7022519222 </a> /<a style={{color:"#000"}} href="tel:+917022520222" className="new_karthik_heading_here">+91 7022520222</a>  
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="copyright-text" style={{ color:"#000"}}><i class="ri-copyright-line"></i> {footer["20"]}</p>
            </footer>
        </>
    );
};
export default Footer;